import script from "./match.vue?vue&type=script&setup=true&lang=js"
export * from "./match.vue?vue&type=script&setup=true&lang=js"

import "./match.vue?vue&type=style&index=0&id=6a0838cc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0838cc"]])

export default __exports__